/**
 * Wrap Selectize into a directive so that it is reliably executed
 */
finderApp.directive('niSelectize', function () {
    return {
        link: function (scope, element, attr) {
            jQuery(element).selectize();
            scope.$watch('sortBy', function() {
                jQuery(window).trigger('resize');
            });
            jQuery('.selectize-input input').attr('readonly','true'); // a fix for problem with keyboard display on iPad
        }
    };
});